import React,{useState} from "react";
import './Weather.css';
import axios from "axios";
// import FormatedDate from "./FormatedDate";
import WeatherInfo from "./WeatherInfo";
export default function Weather(props){
let[weatherData,setWeatherData]=useState({ready:false});
const [city, setCity] = useState(props.defaultcity);
  function handleresponse(response) {
    console.log(response.data);
 setWeatherData({
   ready: true,
   temperature: response.data.main.temp,
   wind: response.data.wind.speed,
   date: new Date(response.data.dt * 1000),
   humidity: response.data.main.humidity,
   city: response.data.name,
   description: response.data.weather[0].description,
   icon:response.data.weather[0].icon,
    
 });
   
    
  }
 function handleSubmit(event) {
  event.preventDefault();
   searchCity();
 }
 function updateCity(event) {
  setCity(event.target.value);
 
  
 }
 function searchCity() {
  const apikey = "5ff53f947f13bf246d792a6df8f021d8";
  let apiurl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apikey}&units=metric`;
  axios.get(apiurl).then(handleresponse);
  
 }

  if (weatherData.ready) {
    return (
      <div className="weather-app">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-9">
              <input
                type="text"
                placeholder="Search a city"
                className="form-input"
                autoFocus="on" onChange={updateCity}
              />
            </div>
            <div className="col-3">
              <input
                type="submit"
                value="Search"
                className="btn btn-primary w-100"
              />
            </div>
          </div>
        </form>
        <WeatherInfo data={weatherData} />
      </div>
    );
  }else{
    searchCity();
    return "Loading.."

  }
   
}